import { HelpMessage } from 'utils/constants'
import CIMSTable from 'components/CIMSTable'
import { ConcreteTest } from '../../../types'

const SecondTable: React.FC<ConcreteTest> = (record) => {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Tests
  return (
    <CIMSTable
      records={[record]}
      rowKey="globalId"
      size="small"
      columns={[
        {
          title: 'Air Tested By',
          help: help.AirTestedBy,
          width: 120,
          render: ({ percentAirTestedBy }) =>
            percentAirTestedBy?.technicianName,
        },
        {
          title: 'Slump Tested By',
          help: help.SlumpTestedBy,
          width: 143,
          render: ({ slumpTestedBy }) => slumpTestedBy?.technicianName,
        },
        {
          title: 'Unit Weight Tested By',
          help: help.UnitWeightTestedBy,
          width: 174,
          render: ({ unitWeightTech }) => unitWeightTech?.technicianName,
        },
        {
          title: 'Override Comments',
          help: help.OverrideComments,
          width: 539,
          render: 'overrideComments',
        },
      ]}
    />
  )
}

export default SecondTable
